import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Header, UspBar } from './navigation/header-new';
import ErrorBoundary from './error-handling/ErrorBoundary';
import { FooterContainer } from './navigation/footer/FooterContainer';
import PortalMessages from './PortalMessage';
import { Paths } from '../types/gatsby';
import { ShowLoginPrompt } from './ShowLoginPrompt';
import PrintdealDeco from './PrintdealDeco';
import { SkipLink, SkipTarget } from './SkipLink';

const messages = defineMessages({
  skipToMainContent: {
    id: 'general.skipToMainContent',
    defaultMessage: 'Skip to main content',
  },
  skipToFooter: {
    id: 'general.skipToFooter',
    defaultMessage: 'Skip to footer',
  },
});

interface LayoutProps {
  localizedPaths?: Paths;
  showStickyFooter?: boolean;
  beforeBody?: React.ReactNode;
  children: React.ReactNode;
  isSmallerSearchbar?: boolean;
  disableStickyHeader?: boolean;
  showFooter?: boolean;
}

const Layout = ({
  localizedPaths,
  showStickyFooter = false,
  beforeBody,
  children,
  isSmallerSearchbar,
  disableStickyHeader,
  showFooter = true,
}: LayoutProps) => (
  <>
    <SkipLink target="main-content">
      <FormattedMessage {...messages.skipToMainContent} />
    </SkipLink>
    {showFooter && (
      <SkipLink target="footer">
        <FormattedMessage {...messages.skipToFooter} />
      </SkipLink>
    )}
    <ShowLoginPrompt localizedPaths={localizedPaths} />
    <PortalMessages />
    <ErrorBoundary inline>
      <Header
        localizedPaths={localizedPaths}
        isSearchSmall={isSmallerSearchbar}
        isStickyDisabled={disableStickyHeader}
      />
    </ErrorBoundary>
    <PrintdealDeco />
    <UspBar className="pd-hidden md:pd-block" />
    {beforeBody}
    <SkipTarget id="main-content" />
    <main>
      {children}
    </main>
    {showFooter && (
      <>
        <SkipTarget id="footer" />
        <FooterContainer showStickyFooter={showStickyFooter} />
      </>
    )}
  </>
);

export default Layout;
